<template>
    <div class="">
        <div>
            <ol class="breadcrumb fs-sm mb-1">
                <li class="breadcrumb-item">
                    <router-link to="/dashboard">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Packings</li>
            </ol>
            <h4 class="main-title mb-2">Packings</h4>
        </div>
        <div class="row">
            <div class="col-4" v-can="'packings.create'">
                <form @submit.prevent="submitForm()">
                    <div class="card card-one">
                        <div class="card-header d-flex justify-content-between">
                            <h6 class="card-title" v-if="status">New Packing</h6>
                            <h6 class="card-title" v-else>Update Packing</h6>
                        </div>
                        <div class="card-body">
                            <div class="row g-2">
                                <div class="col-md-12">
                                    <label class="form-label">Packing Code</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Packing Code" :class="{ 'is-invalid': errors.packing_code }" class="form-control" v-model="packing.packing_code" ref="packing_code" />
                                    <span v-if="errors.packing_code"><small class="text-danger">{{ errors.packing_code[0] }}</small></span>
                                </div>
                                <div class="col-md-12">
                                    <label class="form-label">Packing Name</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Packing Name" :class="{ 'is-invalid': errors.packing_name }" class="form-control" v-model="packing.packing_name" />
                                    <span v-if="errors.packing_name"><small class="text-danger">{{ errors.packing_name[0] }}</small></span>
                                </div>
                                <div class="col-md-12">
                                    <label class="form-label">LCL</label>
                                    <input type="number" step="0.01" placeholder="LCL" :class="{ 'is-invalid': errors.lcl }" class="form-control" v-model="packing.lcl" />
                                    <span v-if="errors.lcl"><small class="text-danger">{{ errors.lcl[0] }}</small></span>
                                </div>
                                <div class="col-md-12">
                                    <label class="form-label">UCL</label>
                                    <input type="number" step="0.01" placeholder="UCL" :class="{ 'is-invalid': errors.ucl }" class="form-control" v-model="packing.ucl" />
                                    <span v-if="errors.ucl"><small class="text-danger">{{ errors.ucl[0] }}</small></span>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer text-end">
                            <button type="button" class="btn btn-danger me-2" @click="discard()"><i class="ri-close-line fs-18 lh-1"></i> Back</button>
                            <button type="submit" class="btn btn-primary" >
                                <span v-if="status"><i class="ri-save-line fs-18 lh-1"></i> Submit</span>
                                <span v-else><i class="ri-save-line fs-18 lh-1"></i> Update</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div :class="column">
                <div class="card card-one">
                    <div class="card-header d-flex justify-content-between">
                        <h6 class="card-title">Packings</h6>
                    </div>
                    <div class="card-body">
                        <input class="form-control mb-2" type="text" placeholder="Type keyword and press enter key" v-model="meta.search" @keypress.enter="search()"/>
                        <div class="table-responsive table-responsive-sm">
                            <table class="table table-striped table-sm text-nowrap table-bordered mb-0">
                                <thead>
                                    <tr style="background-color: #9b9b9b; color: white;">
                                        <th class="text-center">#</th>
                                        <th @click="sort('packing_code')">
                                            Packing Code
                                            <span>
                                                <i v-if="meta.keyword=='packing_code' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='packing_code' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('packing_name')">
                                            Packing Name
                                            <span>
                                                <i v-if="meta.keyword=='packing_name' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='packing_name' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('lcl')">
                                            LCL
                                            <span>
                                                <i v-if="meta.keyword=='lcl' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='lcl' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('ucl')">
                                            UCL
                                            <span>
                                                <i v-if="meta.keyword=='ucl' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='ucl' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th class="text-center" v-can="'packings.delete'">Status</th>
                                        <th class="text-center" v-can ="'packings.update'">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="packings.length==0">
                                        <td colspan="7" class="text-center">No records found</td>
                                    </tr>
                                    <tr v-for="packing, key in packings" :key="key">
                                        <td class="text-center">{{ meta.from + key }}</td>
                                        <td>{{ packing.packing_code }}</td>
                                        <td>{{ packing.packing_name }}</td>
                                        <td>{{ packing.lcl }}</td>
                                        <td>{{ packing.ucl }}</td>
                                        <td class="text-center" v-can="'packings.delete'">
                                            <div class="form-switch">
                                                <input class="form-check-input" type="checkbox" role="switch" :id="'packing' + packing.packing_id" :checked="packing.status" :value="packing.status" @change="deletePacking(packing)" />
                                                <label class="custom-control-label" :for="'packing' + packing.packing_id"></label>
                                            </div>
                                        </td>
                                        <td class="text-center" v-can="'packings.update'">
                                            <a href="javascript:void(0)" v-if="packing.status" class="text-success me-2" @click="editPacking(packing)"><i class="ri-pencil-line fs-18 lh-1"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="d-flex justify-content-between align-items-center">
                            <select class="form-select from-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                                <option>10</option>
                                <option>15</option>
                                <option>20</option>
                                <option>25</option>
                                <option>30</option>
                            </select>
                            <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.totalRows }} entries</span>

                            <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    export default {
        components: {
            Pagination,
        },
        data() {
            return {
                column:'',
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "packing_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                },
                packing: {
                    packing_id: "",
                    packing_code: "",
                    packing_name: "",
                    lcl: "",
                    ucl: "",
                },
                status: true,
                packings: [],
                errors: [],
            };
        },
        mounted() {
            this.create_packing = this.$store.getters.permissions.filter(function(element){
                return element.ability.ability.includes('packings.create')
            })
            if(this.create_packing.length){
                this.column = 'col-8'
            }else{
                this.column = 'col-12'
            }
            this.index();
        },

        methods: {
            submitForm() {
                let vm = this;
                if (vm.status) {
                    vm.addPacking();
                } else {
                    vm.updatePacking();
                }
            },
            index() {
                let vm = this;
                vm.$store
                    .dispatch("post", { uri: "paginatePackings", data: vm.meta })
                    .then((response) => {
                        vm.packings = response.data.data;
                        vm.meta.totalRows = response.data.meta.total;
                        vm.meta.lastPage = response.data.meta.last_page;
                        vm.meta.from = response.data.meta.from;
                        vm.meta.to = response.data.meta.to;
                        vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            addPacking() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "addPacking", data: vm.packing })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", "Packing Added successfully");
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            updatePacking() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "updatePacking", data: vm.packing })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", "Packing is successfully updated");
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            editPacking(packing) {
                let vm = this;
                vm.$refs.packing_code.focus();
                vm.errors = [];
                vm.status = false;
                vm.packing = packing;
            },

            deletePacking(packing) {
                let vm = this;
                let loader = vm.$loading.show();
                packing.status = packing.status == 1 ? 0 : 1;
                vm.$store
                    .dispatch("post", { uri: "deletePacking", data: packing })
                    .then(function (response) {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },

            onPageChange(page) {
                let vm = this;
                vm.meta.page = page;
                vm.index();
            },
            sort(field) {
                let vm = this;
                vm.meta.keyword = field;
                vm.meta.order_by = vm.meta.order_by == "asc" ? "desc" : "asc";
                vm.index();
            },
            discard() {
                let vm = this;
                vm.packing.packing_code = "";
                vm.packing.packing_name = "";
                vm.packing.lcl = "";
                vm.packing.ucl = "";
                vm.$refs.packing_code.focus();
                vm.errors = [];
                vm.status = true;
                vm.index();
            },
            onPerPageChange() {
                this.meta.page = 1;
                this.index();
            },
        },
    };
</script>
